import { IColumn, IOption } from './radarTypes';
import { polarToX, polarToY, RANGE_MAX } from './radarUtil';
import fogIcon from './images/fog.png';

const FOG_DISPLAY_VAL = 3; // 一团迷雾时展示数值

const getShapePoints = (points: number[][]) => {
    let d = 'M' + points[0][0].toFixed(4) + ',' + points[0][1].toFixed(4);
    for (let i = 1; i < points.length; i++) {
        d += 'L' + points[i][0].toFixed(4) + ',' + points[i][1].toFixed(4);
    }
    return d + 'z';
};

export const axis = (opt: IOption) => (col: IColumn) => {
    return `
    <polyline class="axis" points="${getPolylines([
        [0, 0],
        [polarToX(col.angle as number, opt.chartSize / 2), polarToY(col.angle as number, opt.chartSize / 2)],
    ])}">
    </polyline>
    `;
};

const spiderPoints = (points: number[][]) => {
    return points.map((point: number[]) => {
        return `
            <circle class="spider-dot-outer" r="1" cx="${point[0]}" cy="${point[1]}"></circle>
            <circle class="spider-dot-inner" r="0.6" cx="${point[0]}" cy="${point[1]}"></circle>
        `;
    });
};

const getPolylines = (points: number[][]) => {
    const result = points
        .map((point) => {
            return point[0].toFixed(4) + ',' + point[1].toFixed(4);
        })
        .join(' ');
    return result;
};

export const shape = (columns: IColumn[], opt: IOption) => (data: IColumn) => {
    const points = columns.map((col: IColumn) => {
        let val = data[col.key] as number;
        if (val === 0) {
            val = FOG_DISPLAY_VAL / RANGE_MAX;
        }
        val = Math.min(1, val);

        return [
            polarToX(col.angle as number, (val * opt.chartSize) / 2),
            polarToY(col.angle as number, (val * opt.chartSize) / 2),
        ];
    });
    return `
    <g>
        <path class="shape series1" d="${getShapePoints(points)}" fill="${data.color}"></path>
        ${spiderPoints(points).join('')}
    </g>
    `;
};

export const centerGraph = (len: number) => {
    const width = 72;
    const height = 72;
    let offsetY = 0;
    switch (len) {
        case 3:
            offsetY = 10;
            break;

        case 4:
            offsetY = 0;
            break;

        case 5:
            offsetY = 0;
            break;

        case 6:
            offsetY = 0;
            break;
    }
    return `
        <image x="0" y="0"
            width="${width}"
            height="${height}"
            transform="translate(-${width / 2},-${height / 2 + offsetY})"
            xlink:href="${fogIcon}"
        />
        `;
};

export const scale = (opt: IOption, cols: IColumn[], i: number) => {
    const max = opt.chartSize / 2;
    const step = max / opt.scales;
    const distance = step * i;
    const points = [];
    const pointsCount = cols.length;
    for (let j = 0; j < pointsCount; j++) {
        const x = polarToX(cols[j].angle as number, distance);
        const y = polarToY(cols[j].angle as number, distance);
        points.push(`${x},${y}`);
    }
    const pointsResult = points.join(' ');
    return `
    <polygon class="scale" fill="none" points="${pointsResult}"></polygon>
    `;
};
